import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

const programs = ['PLC / SCADA', 'Industrial Automation', 'Data Science', 'Full Stack', 'SAP', 'Embedded Systems'];
const quickLinks = [
  ['Home', '/'], ['About', '/about'], ['Courses', '/courses'],
  ['Placements', '/placements'], ['Contact', '/contact'], ['Apply', '/admission'],
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="lux-cta-full">
        <div>
          <p className="lux-statement__eyebrow">Admissions Open</p>
          <h2>
            Craft your career in<br />
            <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>industrial excellence</em>
          </h2>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/admission" className="btn-lux btn-lux--fill">Apply Now</Link>
            <a href="https://wa.me/918851868521" target="_blank" rel="noreferrer" className="btn-lux btn-lux--line">WhatsApp</a>
          </div>
        </div>
      </div>

      <div className="container footer-grid" style={{ padding: '64px clamp(20px,5vw,48px) 48px' }}>
        <div>
          <p className="nav-lux__brand" style={{ marginBottom: 16, color: 'var(--text)' }}>Bharat Training</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.8, maxWidth: 300, marginBottom: 24 }}>
            Noida&apos;s premier industrial training institute — hands-on PLC, SCADA and automation programs since 2018.
          </p>
          <SocialLinks size="lg" />
        </div>
        <div>
          <h5 style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 20, color: 'var(--text-muted)' }}>Programs</h5>
          {programs.map(p => (
            <Link key={p} to="/courses" className="footer-link">{p}</Link>
          ))}
        </div>
        <div>
          <h5 style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 20, color: 'var(--text-muted)' }}>Explore</h5>
          {quickLinks.map(([label, to]) => (
            <Link key={to} to={to} className="footer-link">{label}</Link>
          ))}
        </div>
        <div>
          <h5 style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: 20, color: 'var(--text-muted)' }}>Visit</h5>
          <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: 16 }}>
            GF E-25, Sector-3, Noida<br />
            Opp. Shiv Mandir, Near Sec-16 Metro
          </p>
          <a href="tel:+918851868521" className="footer-link">+91 88518 68521</a>
          <a href="tel:+918238375399" className="footer-link">+91 82383 75399</a>
          <a href="mailto:hr@bharattraining.com" className="footer-link">hr@bharattraining.com</a>
        </div>
      </div>

      <div style={{ borderTop: '1px solid var(--border)', padding: '20px 0' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, fontSize: 12, color: 'var(--text-muted)' }}>
          <span>© 2026 Bharat Industrial Training</span>
          <span>Sector-3, Noida 201301</span>
        </div>
      </div>
    </footer>
  );
}
